import {fetchRemoteResult} from '../../Api/api-util';
import { JsonError } from 'survey-knockout';
const endpoint = '/Settings/IOFormat/';

let _dataEntitiesPromise;
let _ioTypesPromise;
const _attributeCache = [];

export default {
    getEntities() {
        return _dataEntitiesPromise || (
            _dataEntitiesPromise = fetchRemoteResult(`${endpoint}GetDataEntitiesAsync`)
        );
    },
    getAttributes(entityId,entityName) {
        return new Promise((resolve, reject) => {
            var cached = _attributeCache.find((entry) => entry.id === entityId);

            if(cached) {
                resolve(cached.values);
            } else {
                fetchRemoteResult(`${endpoint}GetDataAttributesAsync?entityId=${entityId}`)
                    .then((value) => {

                        const values = value.map((attribute) =>{
                            return {
                                entityId: entityId,
                                label: `${entityName} - ${attribute.text}`,
                                value: attribute.value
                            };
                        });

                        _attributeCache.push({ id: entityId, values: values });
                        resolve(values);
                    }, reject);
            }
        });
    },
    createIoFormat(model) {

        //We need to wrap our model with form data, as we may be sending a file to the controller
        const data = new FormData();
        const keys = Object.keys(model);

        keys.forEach((key) => {
            if(model[key] !== null)
                data.append(key, model[key]);
        });

        return fetchRemoteResult(`${endpoint}Index`, {
            method: 'POST',
            body: data
        });
    },
    createIoItems(id, items) {

        const model = {
            formatId: id,
            models: items
        };

        return fetchRemoteResult(`${endpoint}${id}/IOItem/CreateBatch`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        });
    },
    getIoItemTypes() {
        const id = '00000000-0000-0000-0000-000000000000';
        return _ioTypesPromise || (_ioTypesPromise = fetchRemoteResult(`${endpoint}${id}/IOItem/GetTypes`));
    },
    listIoFormats() {
        return fetchRemoteResult(`${endpoint}List`);
    },
    cloneIoFormat(id) {
        return fetchRemoteResult(`${endpoint}Clone/${id}`, {
            method: 'POST'
        });
    }
};

export {
    endpoint
};